const testimonials = [
  {
    name: "James L.",
    location: "Greenville, SC",
    rating: 5,
    text: "Had an international BMW plant business trip from GSP in 5 days. My passport had expired 3 months earlier. Fast Passport Center expedited it in 4 days. Called them from downtown Greenville and someone picked up immediately. Absolute lifesavers.",
    service: "Emergency Passport",
  },
  {
    name: "Catherine W.",
    location: "Simpsonville, SC",
    rating: 5,
    text: "We planned a Europe trip months out and my name had changed since my last passport. Fast Passport Center guided me through the name change documentation perfectly. Had the corrected passport back in 6 business days. Wonderful service.",
    service: "Name Change",
  },
  {
    name: "Tyler B.",
    location: "Mauldin, SC",
    rating: 5,
    text: "Lost my passport a week before a work trip to Canada. They walked me through the DS-64 form, told me exactly what to bring to the Greenville post office, and submitted it the next day. Got it back in time. Couldn't believe it worked that fast.",
    service: "Lost Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function GreenvilleSCTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Greenville Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Greenville, Simpsonville, Mauldin, Greer, and the Upstate who trusted Fast Passport Center.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">{t.service}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}